@if (contentData$ | async; as content) {
  <div
    class="product-disclaimer text-subtle-gray_1000"
    [innerHTML]="content | prepareHtml"
  ></div>
}
